'use client';

import { ArticleCard, CardDate, Title } from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreviewRailSimple } from '@/app_lib/types/ArticlePreview';

export const ArticleCardRailSimple = ({
  article,
  className,
  useRelativeTime = false,
}: {
  article: ArticlePreviewRailSimple;
  className?: string;
  useRelativeTime?: boolean;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    // NOTE: Should this gap use a token?
    <ArticleCard
      className={className}
      variant='railSimple'
    >
      <Title
        contentCardTrackingData={generateContentCardTrackingData({
          article: getExtendedArticle(article),
          cardPosition: 1,
          clickTarget: 'headline',
          moduleType: 'rail_simple',
        })}
        title={article.title}
        url={article.url}
        variant='railSimple'
      />
      <CardDate
        dateGmt={article.dateGmt}
        useRelativeTime={useRelativeTime}
        variant='railSimple'
      />
    </ArticleCard>
  );
};
